export default {
  id: 'what-is-tradelab',
  title: 'What is TradeReflex AI?',
  content: `## What is TradeReflex AI?

TradeLab is a **behavioral paper trading platform** built for the Indian stock market (NSE). You trade with **₹10 lakh of virtual capital** — no real money, no real risk.

The goal is not just to track profit and loss. TradeLab is designed to train you to trade with **discipline, consistency, and sound risk management** before you ever deploy real capital.

> TradeLab is a coaching platform first. A trading simulator second.

---

## What makes TradeLab different?

Most paper trading apps let you buy and sell and show you a P&L number. TradeLab goes further — it scores **how** you make decisions.

- Did you define your stop loss before entering?
- Was your risk:reward ratio acceptable?
- Are you revenge trading after a loss?
- Do you exit too early when a trade is working?

These behavioral patterns are tracked, scored, and shown back to you so you can improve over time.

---

## What TradeLab is NOT

- It is **not** a real trading platform — no real money is involved
- It does **not** show live streaming prices — prices are fetched periodically
- It is **not** a stock recommendation service
- It is **not** a get-rich-quick tool

---

## Who is it for?

- Beginners who want to learn how trading works without financial risk
- Traders who want to build discipline before going live
- Experienced traders who want to test strategies in a safe environment

---

## Core Philosophy

**Process over outcome.** A good trade is one where you followed your rules — even if it ends in a loss. A bad trade is one where you broke your rules — even if it ends in a profit.

TradeLab measures your process. The market measures your outcome. Over time, a good process leads to good outcomes.`,
};
